import React, { useState, useEffect, useRef } from "react";
import history from "../../APIs/History";
import config from "../../config.json";
import "./NavDropdown.css";

const NavDropdown = ({ style }) => {
    const clientCode = localStorage.getItem("carrierClientId");
    const carrierId = localStorage.getItem("carrierId");
    const currentPath = history.location.pathname;
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, []);

    const entry = config.dropDownNavigation.find(e => e.clientCode === clientCode);
    if (!entry) return null;

    const allowed = entry.carrierIds === "*" || (Array.isArray(entry.carrierIds) && entry.carrierIds.includes(carrierId));
    if (!allowed) return null;

    const currentIndex = entry.routes.findIndex(r => currentPath === `/${r}`);
    const currentLabel = entry.labels
        ? entry.labels[currentIndex === -1 ? 0 : currentIndex]
        : entry.routes[currentIndex === -1 ? 0 : currentIndex];

    const handleSelect = (route) => {
        localStorage.setItem("lastRoute", `/${route}`);
        setOpen(false);
        history.push(`/${route}`);
    };

    return (
        <div className="dropdown" style={style} ref={containerRef}>
            <button
                type="button"
                className="btn btn-sm btn-outline-primary dropdown-toggle"
                onClick={() => setOpen(!open)}
            >
                {currentLabel}
                {currentLabel !== "Payments" ? <span className="badge badge-warning ml-1 navDropdownNewBadge">New</span> : null}
            </button>
            {open ? (
                <div className="dropdown-menu show" style={{ position: "absolute" }}>
                    {entry.routes.map((route, i) => {
                        const label = entry.labels ? entry.labels[i] : route;
                        return (
                            <button
                                type="button"
                                key={route}
                                className={`dropdown-item ${currentPath === `/${route}` ? "active" : ""}`}
                                onClick={() => handleSelect(route)}
                            >
                                {label}
                                {label === "Payments" ? <span className="badge badge-warning ml-1 navDropdownNewBadge">New</span> : null}
                            </button>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};

export default NavDropdown;
